import styled from '@emotion/styled';
import { Typography } from 'antd';
import { motion } from 'motion/react';
import type { ReactNode } from 'react';
import { CheckIcon } from '@phosphor-icons/react';

interface StyledFilterValueProps {
  $isSelected?: boolean;
}

const StyledFilterValue = styled(motion.button)<StyledFilterValueProps>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 12px 4px;
  height: 40px;
  width: 100%;
  border: none;
  outline: none;
  background-color: #ffffff;
  color: #171717;
  font-size: 14px;
  font-weight: ${props => (props.$isSelected ? 700 : 400)};
  cursor: pointer;
  border-bottom: 1px solid #edeef2;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
`;

interface IFilterValueProps {
  isSelected?: boolean;
  value: string | number;
  label: string | number | ReactNode;
  onClick: (value: string | number) => void;
  count?: number;
}

const FilterValue = ({ isSelected, value, label, onClick, count }: IFilterValueProps) => {
  return (
    <StyledFilterValue
      type="button"
      $isSelected={isSelected}
      onClick={() => onClick(value)}
      whileTap={{ scale: 0.97 }}
      initial={{
        opacity: 0,
        y: -8,
        scale: 0.98,
        filter: 'blur(4px)',
      }}
      animate={{
        opacity: 1,
        y: 0,
        scale: 1,
        filter: 'blur(0px)',
      }}
      exit={{
        opacity: 0,
        y: 8,
        scale: 0.98,
        filter: 'blur(4px)',
      }}
      transition={{ duration: 0.15, ease: 'easeOut' }}
    >
      <CheckIcon
        weight={isSelected ? 'bold' : 'regular'}
        fill={isSelected ? '#393AFB' : '#868E96'}
      />
      <Typography.Text
        style={{
          flex: 1,
          textAlign: 'left',
        }}
      >
        {label}
      </Typography.Text>
      {typeof count === 'number' && (
        <Typography.Text style={{ fontSize: 14, color: '#868E96' }}>{count}</Typography.Text>
      )}
    </StyledFilterValue>
  );
};

export default FilterValue;
